import CartModel from '../store/Cart/CartModel';

export default class LocalDataStore {
    public static cartSave = function (cart: CartModel) {
        localStorage.setItem('cart', JSON.stringify(cart));
    }
    public static cartGet = function (): CartModel {
        let cart = localStorage.getItem('cart');
        if (cart)
            return JSON.parse(cart);
        else
            return new CartModel();
    }
    public static cartClear = function () {
        localStorage.removeItem('cart');
    }

    public static locationGet = function (): string {
        return localStorage.getItem('location') || '';
    }

    public static locationSet = function (value: string) {
        if(!value) value = ''
        else value = value.toUpperCase()
        return localStorage.setItem('location', value);
    }

    public static locationIdGet = function (): number {
        return parseInt(localStorage.getItem('location_id') || '20');
    }

    public static locationIdSet = function (value: number) {
        if(!value) return;
        return localStorage.setItem('location_id', value.toString());
    }

    public static locationClear = function () {
        localStorage.removeItem('location');
        localStorage.removeItem('location_id');
    }

    public static get = function (name: string) {
        let value = localStorage.getItem(name) || '{}';
        if (value === '{}')
            return undefined
        else
            return JSON.parse(value);
    }

    public static getValue = function (name: string) {
        return localStorage.getItem(name);
    }

    public static set = function (name: string, value: any) {
        return localStorage.setItem(name, JSON.stringify(value));
    }

    public static setValue = function (name: string, value: string) {
        return localStorage.setItem(name, value);
    }

    public static remove = function (name: string) {
        localStorage.removeItem(name);
    }
}
